// extracted by mini-css-extract-plugin
export default {"goBackBtn":"GoBackButton_goBackBtn__GF3s4"};